module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// BlogSidebar

(function (fox, $) {
	'use strict';

	fox.registerWidget('BlogSidebar', {

		/**
		*	required options
		*
		*	'latestCommentsRowTemplate'
		*	'mostPopularPostRowTemplate'
		*/

		configure: function () {
			this.registerOptions('', {
				'embed.container': '#right-blog-info',
				template: 'blog_sidebar_main_template',
				autoRender: true,
				widgets: {
					latestComments: {
						widget: 'Grid',
						template: 'blog_last_comments_container',
						'embed.container': '#last-post-comments',
						autoRender: true,
						'widgets.dl': {
							widget: 'Datalayer',
							method: 'blog.GetBlogLastComments'
						},
						'list.embed.container': '.list'
					},
					latestPopularPosts: {
						widget: 'BlogViewer',
						template: 'blog_last_popular_posts_container',
						'embed.container': '#most-popular-post',
						autoRender: true,
						'widgets.dl': {
							method: 'blog.GetPopularPosts',
						},
						'list.embed.container': '.list'
					}
				},
				handleWom: {
					latestCommentsAddToDom: {
						event: 'addedToDom',
						widget: '#latestComments',
						callback: 'checkDlCollection',
						'params.prefix': 'blogSidebarEvent'
					},
					latestPopularPostsAddToDom: {
						event: 'addedToDom',
						widget: '#latestPopularPosts',
						callback: 'checkDlCollection',
						'params.prefix': 'blogSidebarEvent'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.registerOptions('#latestComments', {
				'list.tpl.row': this.requireOption('latestCommentsRowTemplate'),
				'widgets.dl.limit': this.getOption('lastestCommentLimit') || 3
			});

			this.registerOptions('#latestPopularPosts', {
				'list.tpl.row': this.requireOption('mostPopularPostRowTemplate'),
				'widgets.dl.limit': this.getOption('mostPopularPostLimit') || 3
			});
		
			this.callParent('init', arguments);
		},

		activate: function () {
			fox.each(this.wom('.Grid .Datalayer'), function (dl) {
				dl.load();
			});
		
			this.callParent('activate', arguments);
		},

		checkDlCollection: function (obj, performer) {
			var hideShowBlock = function (hide) {
				if (hide === true) {
					if (this._indom === true) {
						$(this.element).hide();
					}
				} else {
					if (this._indom === true && !$(this.element).is(':visible')) {
						$(this.element).show();
					}
				}
			}

			if (!performer.rwom1('#dl').getCount()) {
				hideShowBlock.call(performer, true);
			} else {
				hideShowBlock.call(performer);
			}
		}

	}, 'Widget');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/blog/blogSidebar.js
// module id = 832
// module chunks = 4